import React from 'react';
import './PageStyle.css';

function Terms() {
  return (
    <div className="page-container">
      <h1>Terms of Use</h1>
      <p>
        Welcome to BESSCO. By accessing or using our website, you agree to comply with the following 
        terms and conditions.
      </p>
      <h3>Use of Our Website</h3>
      <p>
        You may use this website only for lawful purposes. You must not attempt to breach its security, 
        copy, or misuse any of its content.
      </p>
      <h3>Intellectual Property</h3>
      <p>
        All content, logos, trademarks, and materials on this site are the exclusive property of BESSCO 
        and protected under applicable laws.
      </p>
      <h3>Limitation of Liability</h3>
      <p>
        BESSCO shall not be liable for any direct, indirect, or consequential damages resulting from the 
        use or inability to use our website or services.
      </p>
      <h3>Changes to Terms</h3>
      <p>
        We reserve the right to modify these terms at any time. Continued use of the site constitutes acceptance 
        of any updates.
      </p>
    </div>
  );
}

export default Terms;

